import { Pipe, PipeTransform } from "@angular/core";
import { RupeePaisePipe } from "./paise-to-rupee.pipe";
import { priceBreakdown } from "../ts/priceBreakdown";
import { CurrencyPipe } from "@angular/common";

@Pipe({
  name: "breakupDetails"
})
export class BreakupDetailsPipe implements PipeTransform {
  rupeePaisePipe = new RupeePaisePipe();
  currencyPipe = new CurrencyPipe("en-IN");

  transform(details): string {
    let priceDetails: string = "";

    for (let [priceName, priceValue] of Object.entries(details.breakdown)) {
      if (+priceValue > 0 && priceName !== "reverse_final_with_gst") {
        priceValue = this.rupeePaisePipe.transform(+priceValue, "rupee");
        priceDetails = `${priceDetails}\n${
          priceBreakdown[priceName] ? priceBreakdown[priceName] : priceName
        }: ${this.currencyPipe.transform(+priceValue, "INR")}`;
      }
    }

    if (details?.breakdown?.reverse_final_with_gst) {
      let priceValue = this.rupeePaisePipe.transform(
        details?.breakdown?.reverse_final_with_gst,
        "rupee"
      );
      priceDetails = `${priceDetails}\n${
        priceBreakdown["reverse_final_with_gst"]
      }: ${this.currencyPipe.transform(+priceValue, "INR")}`;
    }
    return priceDetails;
  }
}
